import {Component} from "./Component";
import {getParent, hasParent} from "../util/dom";
import {createLogger} from "../util/logger";

const console = createLogger("Dialog");

export class Dialog extends Component {
    static name = "dialog";

    get name() {
        return Dialog.name;
    }


    constructor(el, props) {
        super(el);

        /**
         * Reference to close button
         * @type {HTMLElement|HTMLElement[]|null}
         */
        this.$close = this.$("close");

        /**
         * Reference to dialog content
         * @type {HTMLElement|HTMLElement[]|null}
         */
        this.$content = this.$("content");

        /**
         * Indicates open state of dialog
         * @type {boolean}
         */
        this.opened = false;


        // this.addEventListener(document.body, "touchstart", this.onClickOutside.bind(this));
        this.addEventListener(document.body, "mousedown", this.onClickOutside.bind(this));

        this.addEventListener(this.$close, "click", this.onClickClose.bind(this));
    }


    /**
     * Handles clicks on close button
     * @param {MouseEvent} e
     */
    onClickClose(e) {
        this.close();
    }

    /**
     * Click handler closes dialog on outside click and opens dialog wwhen clicking href that targets dialog with id
     * @param e
     */
    onClickOutside(e) {

        console.log("onClickOutside", this, e);

        if (!this.opened) {

            const target = getParent(e.target, "[data-dialog]")?.getAttribute("data-dialog");

            if (!target?.length) return;

            console.log("onClickOutside open", {target, id: this.el.id});
            if (target.substring(1) === this.el.id) {
                e.stopPropagation();
                this.open();
            }

            return;
        }

        if (!hasParent(e.target, this.$content)) {
            console.log("onClickOutside close", {target: e.target, id: this.el.id});
            this.close();
        }

    }

    close() {
        console.log("close", this);
        if (!this.opened) return;
        this.opened = false;

        this.el.classList.remove("dialog--open");

    }

    open() {
        console.log("open", this);
        if (this.opened) return;
        this.opened = true;

        this.el.classList.add("dialog--open");
    }


}
